var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.link ? 'router-link' : 'button',{tag:"component",class:_vm.buttonClass,attrs:{"type":!_vm.link ? _vm.type : false,"to":_vm.link}},[_vm._t("default",function(){return [_vm._v(" Button ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }